// extracted by mini-css-extract-plugin
module.exports = {"tooltip_content":"styles_tooltip_content__JcsZW","visible":"styles_visible__1iKNq"};